import { Button, Grid2, Stack } from "@mui/material";
import {
  ADD_RIGHT,
  DELETE_RIGHT,
  UPDATE_RIGHT,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
} from "../../../../../utils/constants";
import CheckboxInput from "../../../input/CheckboxInput";

const rightMapper: { [key: string]: string } = {
  [VIEW_RIGHT]: "Xem",
  [VIEWOFOTHER_RIGHT]: "Xem của người khác",
  [ADD_RIGHT]: "Thêm mới",
  [UPDATE_RIGHT]: "Cập nhật",
  [DELETE_RIGHT]: "Xóa",
};

interface ICheckBoxComponent {
  right: string;
  module: any;
  currentRight: any;
  addOrUpdateRight: (obj: { type: string; value: boolean }) => void;
  trangThais: any[];
}

function CheckBoxComponent({
  right,
  module,
  currentRight,
  addOrUpdateRight,
  trangThais = [],
}: ICheckBoxComponent) {
  //   const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <Grid2 size={{ xs: right === "viewOfOther" ? 3 : 2.25 }}>
      <Stack sx={{ width: "100%" }}>
        <CheckboxInput
          label={rightMapper[right]}
          checked={currentRight?.[right] || false}
          onChange={(e) => {
            addOrUpdateRight({ type: right, value: e.target.checked });
          }}
        />
        {currentRight?.[right] === true &&
          !!trangThais &&
          trangThais.length > 0 && (
            <Button variant="outlined" sx={{ width: "fit-content" }}>
              Trạng thái
            </Button>
          )}
      </Stack>
    </Grid2>
  );
}
export default CheckBoxComponent;
